/* eslint-disable tailwindcss/no-arbitrary-value */
'use client';

import { MaterialIcon } from 'components/modulab/MaterialIcon';
import { useState } from 'react';
import { Translated } from 'utils/staticText';
import {
  ITrackingProductPageBaseParameters,
  trackQAExpandOrCollapse,
} from '../../lib/tracking';
import { FaqStaticText } from './i18n';

export function Faq({
  tracking,
  staticText,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  staticText: Translated<typeof FaqStaticText> & { [key: string]: any };
  tracking: ITrackingProductPageBaseParameters;
}): JSX.Element {
  const [openQuestion, setOpenQuestion] = useState<number | null>(null);

  const handleOpenQuestion = (index: number) =>
    setOpenQuestion(openQuestion === index ? null : index);

  const visibleAccordions = 10;

  const faqStaticKey = 'faqContent';
  const staticFAQContent = staticText[faqStaticKey] ?? staticText.faqContent;
  return (
    <section className="mhg-alpha-rewards-lead-capture-section">
      <div className="mhg-alpha-rewards-lead-capture-heading-container">
        <div className="mhg-alpha-display-1 not-italic text-text/primary">
          {staticText.faqHeading}
        </div>
        {staticText.faqSubHeading && (
          <div className="mhg-alpha-rewards-lead-capture-subheading">
            {staticText.faqSubHeading}
          </div>
        )}
      </div>
      <div className="mhg-alpha-rewards-lead-capture-faq-card">
        <div className="mhg-alpha-rewards-lead-capture-faq-content">
          {staticFAQContent
            .slice(0, visibleAccordions)
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((item: any, index: number) => (
              <div
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                className="mhg-alpha-rewards-lead-capture-faq-accordion"
              >
                <button
                  onClick={() => {
                    handleOpenQuestion(index);
                    trackQAExpandOrCollapse({
                      ...tracking,
                      componentTitle: item.question,
                      isCollapsed: openQuestion === index,
                    });
                  }}
                  type="button"
                  className={`${
                    openQuestion === index
                      ? 'mhg-alpha-rewards-lead-capture-faq-answer-wrapper'
                      : 'mhg-alpha-rewards-lead-capture-faq-answer-wrapper-expand'
                  }`}
                >
                  <span
                    className="mhg-alpha-rewards-lead-capture-faq-answer-label"
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{ __html: item.question }}
                  />
                  <Icon index={index} open={openQuestion ?? -1} />
                </button>
                {openQuestion === index && (
                  <div className="mhg-alpha-rewards-lead-capture-faq-question-wrapper">
                    <div
                      className="mhg-alpha-rewards-lead-capture-faq-question-label"
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{ __html: item.answer }}
                    />
                  </div>
                )}
              </div>
            ))}
        </div>
      </div>
    </section>
  );
}

interface IconProps {
  index: number;
  open: number;
}

const Icon: React.FC<IconProps> = ({ index, open }) => (
  <MaterialIcon
    icon="expand_more"
    className={`mhg-alpha-rewards-lead-capture-faq-icon transition-transform duration-300 ease-in-out ${
      index === open ? 'rotate-180' : ''
    }`}
  />
);
